// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"8053c6f9","254":"f7370d56","301":"1ade7427","314":"3fdbe5ba","407":"a0a28c1b","453":"92b0f5dc","711":"fd077f1d","716":"eaf85c72","835":"f25e8c7e","879":"854850f7"}[chunkId] + ".chunk.js";
};